import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import RSVPForm from './pages/RSVPForm';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ThankYou from './pages/ThankYou';
import WeddingInvitation from './pages/WeddingInvitation';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/rsvp/:token" element={<RSVPForm />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="/invitation/:token" element={<WeddingInvitation />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
